(function($) {
    var searchToggle = $('#navbarSearchToggle');
    var searchForm = $('#navbarSearch');
    var primaryNav = $('#primaryNavigation .primary-nav');

    // Toggles search form
    searchToggle.on('click', function() {
        $this = $(this);

        /*Sets focus after delay*/
        setTimeout(function() {
            $('#navbarSearch .form-control').focus();
        }, 350);

        if($this.hasClass('is-active')) {
            $this.closest('.nav-item').removeClass('is-active');
            $this.removeClass('is-active');
            searchForm.removeClass('is-visible');
            $('.navbar-primary .nav-item:not(.is-search)').removeClass('is-inactive');

            if ($(window).width() >= 992) {
                primaryNav.removeClass('is-hidden');
            }

        } else {
            $this.closest('.nav-item').addClass('is-active');
            $this.addClass('is-active');
            searchForm.addClass('is-visible');
            $('.navbar-primary .nav-item:not(.is-search)').addClass('is-inactive');

            if ($(window).width() >= 992) {
                primaryNav.addClass('is-hidden');
            }
        }
    });

})(jQuery);